import Vue from 'vue'
import ABtn from "@/wrapper-component/ABtn.vue";
import AExpansionPanel from "@/wrapper-component/AExpansionPanel.vue";
import AList from '@/wrapper-component/AList.vue';
import AChip from '@/wrapper-component/AChip.vue';
import ADataTable from '@/wrapper-component/ADataTable.vue';
import PageHeader from '@/components/PageHeader.vue';
import PageContainer from '@/components/PageContainer.vue';
import AAutoComplete from '@/wrapper-component/AAutocompletes';
import ADialog from "@/wrapper-component/ADialog.vue";
import ARichTextEditor from "@/components/ARichTextEditor.vue";
import CloseIcon from "@/components/CloseIcon.vue";
import AMenu from "@/wrapper-component/AMenu.vue";
import AToolbar from "@/wrapper-component/AToolbar.vue";

const globalComponents = [CloseIcon, ABtn, AExpansionPanel, AList, AChip, ADataTable, PageHeader, PageContainer, AAutoComplete, ADialog, ARichTextEditor, AMenu, AToolbar]

globalComponents.forEach((component) => Vue.component(component.name, component))

export default () => { }